import{a as t}from"./chunk-K26VP6CL.js";function u(r,n,a){let o=r.length-n.length;if(o===0)return r(...n);if(o===1)return t(r,n,a);throw new Error("Wrong number of arguments")}export{u as a};
